import { create } from "zustand/react";

interface IConsent {
  consent: boolean;
  updateConsent: (value: boolean) => void;
}

export const useConsentStore = create<IConsent>((set) => ({
  consent: false,
  updateConsent: (value) => set({ consent: value }),
}));
